import { configureStore } from '@reduxjs/toolkit';
import pagesSlice from './pagesSlice';
import selectedPageSlice from './selectedPageSlice';
import selectedComponentSlice from './selectedComponentSlice';
import componentsTabSlice from './componentsTabSlice';
import canvasResolution from './canvasResolutionSlice';
import selectedTemplate from './selectedTemplateSlice';
import cssVariables from './cssVariablesSlice';
import canvasCssIsLoading from './canvasCssIsLoading';
import customFontsSlice from './customFontsSlice';
import visualizationModeSlice from './visualizationModeSlice';
import hoverElementSlice from './hoverElementSlice.js';
import mockImagesSlice from './mockImagesSlice.js';
import imagesSlice from './imagesSlice.js';
import { createStateSyncMiddleware, initStateWithPrevTab } from 'redux-state-sync';
import megaMenuSlice from './megaMenuSlice';

export const generateStore = (viewId) => {
	const store = configureStore({
		// middleware: (getDefaultMiddleware) => getDefaultMiddleware({
		//     immutableCheck: false,
		//     serializableCheck: false,
		// }),
		middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([createStateSyncMiddleware({ viewId })]),
		reducer: {
			pages: pagesSlice,
			selectPage: selectedPageSlice,
			selectComponent: selectedComponentSlice,
			componentsTab: componentsTabSlice,
			canvasResolution: canvasResolution,
			selectedTemplate: selectedTemplate,
			cssVariables: cssVariables,
			canvasCssIsLoading: canvasCssIsLoading,
			customFonts: customFontsSlice,
			visualizationMode: visualizationModeSlice,
			hoverElement: hoverElementSlice,
			mockImages: mockImagesSlice,
			images: imagesSlice,
			megaMenu: megaMenuSlice,
		},
	});

	return store;
};

export const store = configureStore({
	// middleware: (getDefaultMiddleware) => getDefaultMiddleware({
	//     immutableCheck: false,
	//     serializableCheck: false,
	// }),
	middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([createStateSyncMiddleware()]),
	reducer: {
		pages: pagesSlice,
		selectPage: selectedPageSlice,
		selectComponent: selectedComponentSlice,
		componentsTab: componentsTabSlice,
		canvasResolution: canvasResolution,
		selectedTemplate: selectedTemplate,
		cssVariables: cssVariables,
		canvasCssIsLoading: canvasCssIsLoading,
		customFonts: customFontsSlice,
		visualizationMode: visualizationModeSlice,
		hoverElement: hoverElementSlice,
		mockImages: mockImagesSlice,
		images: imagesSlice,
	},
});

initStateWithPrevTab(store);
